module.exports = __webpack_public_path__ + "img/位图.700b808d.png";